import { DialogTrigger, Dialog, Modal } from 'react-aria-components';
import { useForm, SubmitHandler } from 'react-hook-form';

import Button from '@/components/Button/Button';
import SelectField from '@/components/SelectField/SelectField';

type Template = {
  id: number;
  body: string;
};

type SelectFormData = {
  selectedTemplateId: string;
};

type Props = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  templates: Template[];
  onSubmit: (selectedTemplate: Template) => void;
  label: string;
};

export const SelectTemplateDialog = ({ isOpen, setIsOpen, templates, onSubmit, label }: Props) => {
  const { control, handleSubmit } = useForm<SelectFormData>({
    defaultValues: {
      selectedTemplateId: templates[0]?.id.toString(),
    },
  });

  const items = templates.map((t) => ({
    label: t.body.length > 30 ? `${t.body.slice(0, 30)}...` : t.body,
    value: t.id.toString(),
  }));

  const handleFormSubmit: SubmitHandler<SelectFormData> = (data) => {
    const selected = templates.find((t) => t.id.toString() === data.selectedTemplateId);
    if (selected) {
      onSubmit(selected);
    }
    setIsOpen(false);
  };

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
    >
      <Modal className="fixed inset-0 z-50 flex h-full w-full items-center justify-center bg-black/50">
        <Dialog className="w-[600px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <h1 className="mb-6 text-xl font-bold">定型文を選択</h1>

          <form
            onSubmit={handleSubmit(handleFormSubmit)}
            className="space-y-6"
          >
            <SelectField
              name="selectedTemplateId"
              label={label}
              control={control}
              items={items}
              required
            />

            <div className="mt-6 flex justify-end space-x-4">
              <Button
                type="button"
                size="md"
                variant="outline"
                onClick={() => setIsOpen(false)}
              >
                戻る
              </Button>
              <Button
                type="submit"
                size="md"
                variant="solid-fill"
              >
                挿入
              </Button>
            </div>
          </form>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
